module.exports = __webpack_public_path__ + "assets/img/help_pagination01-4.9a71361d.svg";